/**
 * Baut den `oldValue`-Getter für ein computed über eine Liste: gibt die vorherige
 * Array-Referenz zurück, solange sich die Signatur nicht ändert (verhindert Re-Renders).
 * Ersetzt die früher pro computed duplizierte Logik im useFileHistoryStore.
 */
export function stableBySignature<T>(
  build: () => T[],
  signature: (items: T[]) => string,
): (oldValue: T[] | undefined) => T[] {
  return (oldValue) => {
    const next = build()
    const nextSig = signature(next)
    const oldSig = oldValue ? signature(oldValue) : undefined
    return nextSig === oldSig && oldValue ? oldValue : next
  }
}
